import { createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  updateInputField: ['inputValue'],
  setValidationError: [],
  submitAnswer: ['answer'],

  startDrag: [],
  stopDrag: [],
  toolTipOn: [],
  toolTipOff: [],

  clearForms: [],
})
